var _defs, _path, _path2, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGooglePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ea4335;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fdbd00;\n      }\n\n      .cls-3 {\n        fill: #2da94f;\n      }\n\n      .cls-4 {\n        fill: #297aec;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M439.29,124.14c-32.27-6.53-84.3-15.36-98.83,15.02-44.42,76.95-69.93,157.48-89.13,192.03,2.02,1.16,90.5,52.5,96.76,55.54,19.89,9.65,53.1,5.31,67.25-20.21,39.25-70.79,29.27-52.36,70.97-124.59,26.95-46.68-6.74-109.64-47.03-117.79h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M160.1,436.52c-21.67-24.79-37.56-74.38-18.52-102.15,55.62-96.34,100.14-154.66,135.16-213.11,18.57,10.72,92.97,52.92,97.92,57.27,16.62,14.58,30.39,42.44,15.37,67.45-41.68,69.38-58.78,100.79-101.14,174.16-26.95,46.69-101.71,47.35-128.78,16.38Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M359.6,75.03c-43.34-25.33-65.62-22.01-88.93-18.27-21.19,5.3-49.85,20.7-61.92,40.48-30.47,49.91-59.33,99.3-96.72,166.22-11.52,20.61-2.97,45.94,7.66,55.99,7.2,6.81,60.19,36.05,69.97,40.26,13.83,5.95,34.55,1.81,47.05-11.05,3.45-3.55,82.51-139.34,104.77-179.39,9.4-16.9,17.86-26.25,31.91-35.27,27.15-14.25,48.34-16.08,80.81-4.21,0,0-70.66-40.96-94.59-54.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.71,393.7c-43.61-24.87-51.87-45.83-60.29-67.88-6.01-21-7-53.51,4.1-73.87,27.99-51.34,27.79-51.6,67.05-117.44,12.09-20.28,38.3-25.54,52.32-21.36,9.5,2.83,61.32,34.1,69.85,40.47,12.07,9.01,18.84,29.02,13.95,46.27-1.35,4.76-50.88,91.69-74.43,131-9.94,16.59-13.81,28.59-14.59,45.27,1.24,30.63,10.24,49.91,36.76,72.09,0,0-70.8-40.72-94.71-54.55h0Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/google-pay.f472c0ceb8c5b420127ac2068a015900.svg";
export { ForwardRef as ReactComponent };